<template>
    <el-form label-position="top">
        <el-form-item>
            <el-input :readonly="true" :rows="27" type="textarea" v-model="value"></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    data() {
        return {
            value: `
导入模板：
{
  "conntype": "协议",
  "connconf": {
    "host":"服务器IP地址",
    "port":"端口号",
    "username":"用户名",
    "password":"密码",
    "vhost":"虚拟主机名称",
    "ssl":"是否使用SSL"
  }
}
例子：
{
  "conntype": "RMQ",
  "connconf": {
    "host":"127.0.0.1",
    "port":"5672",
    "username":"admin",
    "password":"111111",
    "vhost":"v_admin",
    "ssl":"false"
  }
}
`
        }
    }
};
</script>
